module.exports = __webpack_public_path__ + "static/media/app.befa7ad8.png";